export const USER_DATA_KEY = 'user-data';
export const CONFIG_DATA_KEY = 'config-data';
export const PREVIOUS_URL = 'previousurl';
export const CUSTOMER_ID = 'customerid';
export const SLOAN_CPQ_USER_KEY = 'sloancpq|';
